import React, { useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { PaymentApproveReject } from '@src/store/slices/reconciliation';
import * as HELPER from "@src/config/helper";
import ReactPanZoom from 'react-image-pan-zoom-rotate';
import ConfirmPopUp from '../common/ConfirmPopUp';
import { toast } from 'react-toastify';
import FullPageLoader from '../../src/common/FullPageLoader';
import AgentRemarksBox from '../common/AgentRemarksBox';

type OptionType = {
  value: number;
  label: string;
};

const ReconciliationDetail: React.FC = () => {
    // eslint-disable-next-line 
    let [loading, setLoading] = useState(false);
    const queryParams = useParams();
    const reconciliation_id = queryParams.id;

    const [selectedReason, setSelectedReason] = useState<OptionType | null>(null);
    const [recoRemarks, setRecoRemarks] = useState('');
    const [modalVisible, setModalVisible] = useState<string | null>(null);
    const location = useLocation(); // Get the current location of the app
    const reconDetail: any = location.state?.item; 
    const paymentTypeList = location.state?.paymentTypeList; 
    const paymentMethodList = location.state?.paymentMethodList;
    const reasonList = location.state?.reasonList;

    const ShowRejectModel = (type: string) => {
        setRecoRemarks('');
        setModalVisible(type);
    };

    const handleReasonChange = (selectedOption: OptionType | null) => {
        setSelectedReason(selectedOption);
    };

    const confirmYes = async () => {
        try {
            setLoading(true);

            const updateObject = {
            id: reconDetail.id,
            reason_id: selectedReason,
            type: modalVisible === 'reject' ? 'reject' : 'reconciled',
            page: 'reco',
            status: modalVisible === 'reconciled' ? 1 : 2,
            remarks: modalVisible === 'reject' ? recoRemarks.trim() : ''
            };

            const res: any = await PaymentApproveReject(updateObject);

            if (res?.status === 200) {
                toast.success(res.message);

                if (reconDetail) {
                    reconDetail.reco_status = updateObject.status;
                    localStorage.setItem(`recon_detail${reconciliation_id}`, reconDetail.reco_status.toString());
                }
            } else {
                toast.error(res?.message || "Something went wrong.");
            }
        } catch (error) {
            console.error("Error during reconciliation:", error);
            toast.error("An unexpected error occurred.");
        } finally {
            setLoading(false); // Always stop loader — success or fail
            setModalVisible(null);
        }
    };


    const confirmNo = () => {
        setRecoRemarks('');
        setModalVisible(null);
    };

    const getPaymentType = (type: number | string, paymentList: OptionType[]) => {
        const label = paymentList.find(item => item.value === type)?.label || '';
        return label;
    };

    // Helper function to check file type
    const checkPaymentProofType = (filePath: any) => {
        if (filePath) {
            let activeImgfile = filePath?.toLowerCase()?.split('?')?.[0]
            let activeImgFileType = activeImgfile?.split('.')
            activeImgFileType = activeImgFileType?.[activeImgFileType?.length - 1]

            let fileType = 'image'

            if (activeImgFileType === 'pdf') fileType = 'pdf'
            if (['csv', 'xls', 'xlsx'].includes(activeImgFileType)) fileType = "excel"
            if (activeImgFileType === 'doc' || activeImgFileType === "docx") fileType = "word"

            return fileType
        }
        return 'image'
    }

    const paymentProofType = checkPaymentProofType(reconDetail.payment_proof);
    const getPaymentMethod = (method: number | string, paymentMethodList: OptionType[]) => {
        const label = paymentMethodList.find(item => item.value === method)?.label || '';
        return label;
    };

    const recoStatus: any = localStorage.getItem(`recon_detail${reconciliation_id}`);

    return (
        <>
            <FullPageLoader show={loading} />
            <div className='lead-list-outer container-fluid main-outer'>
                <div className=''>
                    <div className="top-heading  top-heading-btn">
                        <h1>{reconDetail?.customer_name}: Policy No. {reconDetail?.policy_no} 
                            <i className='ic-content_copy m-sm-l' 
                                onClick={() => HELPER.handleCopyText(reconDetail?.policy_no)} style={{ cursor: 'pointer' }}>
                            </i>
                        </h1>
                    </div>
                    <div className='row'>
                        <div className='col-md-6'>
                            <div className='payment-proof-outer'>
                                <h2>Payment Received Proof</h2>
                                <ul className='payment-recieved-detail'>
                                    <li>
                                        <label>Customer</label>
                                        <span>{reconDetail?.customer_name}</span>
                                    </li>
                                    <li>
                                        <label>Insurance ID</label>
                                        <span>{reconDetail?.insurance_id}</span>
                                    </li>
                                    <li>
                                        <label>Transaction On</label>
                                        <span>{reconDetail?.transaction_date}</span>
                                    </li>
                                    <li>
                                        <label>Amount</label>
                                        <span>{HELPER.addCurrencyFormatting(reconDetail?.amount) || 0}</span>
                                    </li>
                                    <li>
                                        <label>Type</label>
                                        <span>{getPaymentType(reconDetail.payment_type, paymentTypeList)}</span>
                                    </li>
                                </ul>
                                {/* <div className='proof-upload-bg'>
                                <ReactPanZoom
                                    image={reconDetail.payment_proof}
                                    alt="Check"
                                    />
                                </div> */}
                                <div  className={`carousel image-varification-slider ${reconDetail?.payment_proof ? '' : 'no-payment-proof'}`}>
                                    {reconDetail?.payment_proof ? (
                                        <div className='carousel-slideimg pfd-img-height'>
                                        {paymentProofType !== 'image' ? (
                                            <a href={reconDetail.payment_proof} target="_blank" rel="noreferrer">
                                            <i className={`ic-${paymentProofType}-file pdf-icons-normal-gallery`}></i>
                                            </a>
                                        ) : (
                                            <ReactPanZoom
                                            image={reconDetail.payment_proof}
                                            alt="Check"
                                            />
                                        )}
                                        </div>
                                    ) : (
                                        <div className="no-proof text-center p-3"
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            height: '250px',
                                        }}>
                                            <span>No Proof Found</span>
                                        </div>
                                    )}
                                </div>
                                {/* <div className='bottom-action-btn'>
                                        <div className="image-opt doc-image-opt">
                                    <ul>
                                        
                                        <li>
                                            <a href="#">
                                                <i className="ic-Call-history"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <i className="ic-refresh"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <i className="ic-fullscreen"></i>
                                            </a>
                                        </li>
                                    </ul>
                                    
                                </div>
                                    <div className="btn-line-img d-flex">
                                        <button className="btn-line">Request for Re-upload</button>
                                        <button className="btn-line">Re-upload Docs</button>
                                    </div> 
                                </div> */}
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className='payment-proof-outer reconciliation-details'>
                                <h2>Reconciliation Details</h2>
                                <div className='data-table'>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>Payment Date</td>
                                            {/* <td>{dateFormat(reconDetail?.transaction_date, 'UTC:dd mmm yyyy')}</td> */}
                                            <td>{reconDetail?.transaction_date}</td>
                                        </tr>
                                        <tr>
                                            <td>Payment Amount</td>
                                            <td>{HELPER.addCurrencyFormatting(reconDetail?.amount) || 0}</td>
                                        </tr>
                                        {
                                            (reconDetail?.cheque_no && reconDetail?.cheque_no !=null)
                                                &&
                                            <tr>
                                                <td>Cheque No.</td>
                                                <td><span className='truncate' title={reconDetail?.cheque_no}>{reconDetail?.cheque_no || '-'}</span></td>
                                            </tr>
                                        }
                                        <tr>
                                            <td>Issuing Bank</td>
                                            <td>{reconDetail?.cheque_issuing_bank_name || '-'}</td>
                                        </tr>
                                        <tr>
                                            <td>QR Code</td>
                                            <td className='truncate' title={reconDetail?.transaction_id}>{reconDetail?.transaction_id}</td>
                                        </tr>
                                        <tr>
                                            <td>Mode of Payment</td>
                                            <td>{getPaymentMethod(reconDetail.payment_method, paymentMethodList)}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                </div>
                                {reconDetail?.collection_remarks && (
                                    <AgentRemarksBox
                                        value={reconDetail.collection_remarks}
                                        maxLength={80}
                                        label="Remarks"
                                        readOnly={true}
                                        rows={3}
                                        className="m-md-t"
                                    />
                                )}
                                { 
                                    (recoStatus == 0 || recoStatus == null)
                                        &&
                                    <div className='btn-save-remarks'>
                                        <button className='btn-line m-sm-r' onClick={() => ShowRejectModel('reconciled')}>Reconciled</button>
                                        <button className='btn-line' onClick={() => ShowRejectModel('reject')}>Reject</button>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>

                </div>
                {modalVisible === 'reject' && (
                    <ConfirmPopUp
                        confirmNo={confirmNo}
                        confirmYes={confirmYes}
                        isReasonVisible={true}
                        reasonList = {reasonList}
                        handleChange={handleReasonChange}
                        selectedReason={selectedReason}
                        placeholder= "Select Reason"
                        isConfirmNotVisible={true}
                        // message={translations.RuleEngine?.['Delete_Role_Msg'] || translations.commonMsg?.loading} />
                        message="Are You Sure, You Want To Reject This Reconciliation?">
                        <AgentRemarksBox
                            value={recoRemarks}
                            onChange={setRecoRemarks}
                            maxLength={80}
                            label="Remarks"
                        />
                    </ConfirmPopUp>
                )}

                {modalVisible === "reconciled" && (
                    <ConfirmPopUp
                        confirmNo={confirmNo}
                        confirmYes={confirmYes}
                        isConfirmNotVisible={true}
                        message="Are You Sure, You Want To Verify This Reconciliation?"
                    />
                )}
            </div>
        </>
    )  
}

export default ReconciliationDetail;